
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FilterFaqSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="page-container">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-autocare-blue mb-4">الأسئلة الشائعة</h2>
          <p className="text-gray-600">أسئلة شائعة حول فلاتر المركبات والصيانة</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible>
            <AccordionItem value="item-1">
              <AccordionTrigger>كم مرة يجب أن أغير فلتر الهواء؟</AccordionTrigger>
              <AccordionContent>
                يجب عادة استبدال فلاتر الهواء كل 15,000 إلى 30,000 ميل، حسب ظروف القيادة. إذا كنت تقود بشكل متكرر في المناطق المتربة، قد تحتاج إلى تغييره أكثر.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2">
              <AccordionTrigger>ماذا يحدث إذا لم أغير فلتر الزيت؟</AccordionTrigger>
              <AccordionContent>
                فلتر الزيت المسدود يمكن أن يقيد تدفق الزيت، مما يؤدي إلى تلف المحرك. تغيير فلتر الزيت بانتظام يساعد في الحفاظ على ضغط الزيت المناسب وحماية محركك من التآكل.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3">
              <AccordionTrigger>كيف أعرف إذا كان فلتر الوقود يحتاج للاستبدال؟</AccordionTrigger>
              <AccordionContent>
                العلامات الشائعة تشمل انخفاض أداء المحرك، والخمول غير المنتظم، وانقطاع الإشعال، وصعوبة في التشغيل. معظم الشركات المصنعة توصي باستبدال فلتر الوقود كل 20,000 إلى 40,000 ميل.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4">
              <AccordionTrigger>هل أحتاج حقاً لتغيير فلتر هواء المقصورة؟</AccordionTrigger>
              <AccordionContent>
                نعم، فلتر هواء المقصورة يحافظ على نظافة الهواء داخل سيارتك. الفلتر المسدود يمكن أن يقلل تدفق الهواء من نظام التكييف/التدفئة ويسمح للملوثات بالدخول إلى مركبتك. يجب تغييره كل 15,000 إلى 25,000 ميل.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FilterFaqSection;
